import React from 'react';
import SupportContent from './SupportContent';

const SupportChannels = ({ selectedSupport, setSelectedSupport }) => {
  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
        </div>
        <SupportContent selectedSupport={selectedSupport} />
      </div>
    </section>
  );
};

export default SupportChannels;